import {connect} from "react-redux";
import OrdersPage from "./OrdersPage";
import * as AccountApiActions from "../actions/AccountApiActions";
import * as ShippingApiActions from "../actions/ShippingApiActions";
import * as ViewActions from "../actions/ViewActions";
import {withRouter} from "react-router";

export default connect(null, {...ViewActions, ...AccountApiActions, ...ShippingApiActions})(withRouter(OrdersPage));